// src/components/NotFound.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Page404 = () => {
  return (
    <Container className="mt-5 text-center">
      <Row>
        <Col>
          <h1>404 - Page Not Found</h1>
          <p>Página não encontrada</p>
          <p>Por favor entre em contato com a companhia.</p>
          {/*<Button as={Link} to="/" variant="primary">
            Go to Homepage
          </Button>*/}
        </Col>
      </Row>
    </Container>
  );
};

export default Page404;